<template lang="pug">
v-app
  section
    header.d-flex.row.flex-row.align-items-center.mb-5
      .col
        router-link.button-previous.mr-2(to="/consultor-externo-observaciones-calidad")
          i.fas.fa-chevron-left
        h1.m-0.font-italic.d-inline-block.align-middle
          | Resumen de Pautas&nbsp;
          span.ad_text-secondary {{user.name}}
      .col-2.text-center
        .ad_select.w-100
          select(v-model="year", @change='changeYear($event)')
            option(:value="null" disabled) Selecciona Año
            option(:value="n" v-for="n in years") {{n}}

    section
      .d-flex.row.flex-row.align-items-start.mt-4
        .col
          .card.p-0.ad_border2-primaryLight.rounded-xl
            .card-body
              .col.ad_bg-gray.rounded-lg.py-4
                table.w-100.text-left.table-rounded-body.espacing-table
                  thead
                    tr
                      th.text-center.font-weight-bold(width="12%")
                        | Semana
                      th.text-center.font-weight-bold(width="12%" colspan="2")
                        | Planificación <br> semanal
                      th.text-center.font-weight-bold(width="12%" colspan="2")
                        | Diálogos <br> de desempeño
                      th.text-center.font-weight-bold(width="12%" colspan="2")
                        | Seguimiento <br> diario
                      th.text-center.font-weight-bold(width="12%" colspan="2")
                        | Seguimiento <br> diario
                      th.text-center.font-weight-bold(width="12%" colspan="2")
                        | Confirmación <br> de procesos
                  tbody
                    tr(v-for="(collab,n) in renderedItems" :key="collab.id_eval")
                      td
                        div.justify-content-center
                          | {{ collab.week_number}}                     
                      td
                        div.justify-content-center(v-if="collab.ps == 'No realizado'")                          
                          | {{ collab.ps }}
                        div.justify-content-center(v-else-if="collab.ps == 'N/A'")
                          | N/A
                        div.justify-content-center(v-else)
                          router-link(:to="{name: 'Historial pautas', params: { id: collab.id_eval, collab: collab.user_evaluated, type: 'PS'} }")
                            | {{ collab.ps }}
                      td
                        div.justify-content-center(v-if="collab.ddd == 'No realizado'")
                          | {{ collab.ddd }}
                        div.justify-content-center(v-else-if="collab.ddd == 'N/A'")
                          | N/A
                        div.justify-content-center(v-else)
                          router-link(:to="{name: 'Historial pautas', params: { id: collab.id_eval, collab: collab.user_evaluated, type: 'DDD'} }")
                            | {{ collab.ddd }}
                      td
                        div.justify-content-center(v-if="collab.sda == 'No realizado'")                          
                          | {{ collab.sda }}
                        div.justify-content-center(v-else-if="collab.sda == 'N/A'")
                          | N/A
                        div.justify-content-center(v-else)
                          router-link(:to="{name: 'Historial pautas', params: { id: collab.id_eval, collab: collab.user_evaluated, type: 'SDA'} }")
                            | {{ collab.sda }}
                      td
                        div.justify-content-center(v-if="collab.sdb == 'No realizado'")                          
                            | {{ collab.sdb }}
                        div.justify-content-center(v-else-if="collab.sdb == 'N/A'")
                          | N/A
                        div.justify-content-center(v-else)
                          router-link(:to="{name: 'Historial pautas', params: { id: collab.id_eval, collab: collab.user_evaluated, type: 'SDB'} }")
                            | {{ collab.sdb }}
                      td
                        div.justify-content-center(v-if="collab.cp == 'No realizado'")
                          | {{ collab.cp }}
                        div.justify-content-center(v-else-if="collab.cp == 'N/A'")
                          | N/A
                        div.justify-content-center(v-else)
                          router-link(:to="{name: 'Historial pautas', params: { id: collab.id_eval, type: 'CP'} }")
                            | {{ collab.cp }}
                .row.mt-4
                  .col-auto.ml-auto
                    b-pagination(v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="fill" size="md" class="mb-0", @change="newPage")
                      
</template>

<script>
import moment from "moment";
import { mapActions } from "vuex";

export default {
  name: "PautaResumenExt",

  data() {
    return {
      user: {},
      year: 2019,
      years: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      renderedItems: [],
      items: [],
      fields: [
        {
          key: "week",
          label: "",
          sortable: true,
          sortDirection: "desc",
          thClass: "border-0"
        },
        {
          key: "ps",
          label: "Planificación semanal",
          sortable: true,
          sortDirection: "desc",
          tdClass: "text-center",
          thClass: "text-center border-0 font-weight-bold"
        },
        {
          key: "ddd",
          label: "Diálogos de desempeño",
          sortable: true,
          sortDirection: "desc",
          tdClass: "text-center",
          thClass: "text-center border-0 font-weight-bold"
        },
        {
          key: "sda",
          label: "Seguimiento diario A",
          sortable: true,
          sortDirection: "desc",
          tdClass: "text-center",
          thClass: "text-center border-0 font-weight-bold"
        },
        {
          key: "sdb",
          label: "Seguimiento diario B",
          sortable: true,
          sortDirection: "desc",
          tdClass: "text-center",
          thClass: "text-center border-0 font-weight-bold"
        },
        {
          key: "cp",
          label: "Confirmación de procesos",
          sortable: true,
          sortDirection: "desc",
          tdClass: "text-center",
          thClass: "text-center border-0 font-weight-bold"
        }
      ]
    };
  },
  methods: {
    moment,
    ...mapActions("user", ["getUserById"]),
    ...mapActions("consultant", ["getAnsweredGuidelinesInWeekRange"]),
    newPage(actual_page) {
      const vm = this;
      vm.renderedItems = vm.items.slice(
        (actual_page - 1) * vm.perPage,
        actual_page * vm.perPage
      );
    },
    getEvaluations() {
      const vm = this;
      const user_evaluated = vm.$route.params.id;
      const loading = vm.$toast.loading("Cargando semanas...");      
      vm.getUserById(user_evaluated).then(response => {
        vm.user = response;
        vm.items = [];
        vm.totalRows = 0;        
        const year = vm.year ? vm.year : 2019;
        const data = {
          user_evaluated,
          year
        };
        const PS = vm.user.profile.auth.tabs.includes("planificacion_semanal");
        const DDD = vm.user.profile.auth.tabs.includes("dialogo_desempeno");
        const CP = vm.user.profile.auth.tabs.includes("confirmacion_procesos");
        const SD = vm.user.profile.auth.tabs.includes("seguimiento_diario");
        vm.getAnsweredGuidelinesInWeekRange(data).then(guidelines => {                    
            for (var i = 1; i <= 53; i++) {
              let date = moment(year).add(i, "weeks");
              let weeksGuidelines = guidelines.filter(guideline => {
                return guideline.week_number == i;
              });
              
              if (weeksGuidelines.length > 0) {
                vm.items.push({
                  week: `Semana ${i} de ${date.lang("es").format("MMMM")}, ${year}`,
                  week_number: weeksGuidelines[0].week_number,
                  ps: !PS
                    ? "N/A"
                    : weeksGuidelines[0].PS.typeimpediment 
                    ? weeksGuidelines[0].PS.typeimpediment.name 
                    : weeksGuidelines[0].PS.autonomous 
                    ? 'Autónomo' 
                    : weeksGuidelines[0].PS.questions.length > 0
                    ? weeksGuidelines[0].PS.final_score.toFixed(2) + "%"
                    : "No realizado",
                  ddd: !DDD
                    ? "N/A"
                    : weeksGuidelines[0].DDD.typeimpediment 
                    ? weeksGuidelines[0].DDD.typeimpediment.name 
                    : weeksGuidelines[0].DDD.autonomous 
                    ? 'Autónomo' 
                    : weeksGuidelines[0].DDD.questions.length > 0
                    ? weeksGuidelines[0].DDD.final_score.toFixed(2) + "%"
                    : "No realizado",
                  sda: !SD
                    ? "N/A"
                    : weeksGuidelines[0].SDA.typeimpediment 
                    ? weeksGuidelines[0].SDA.typeimpediment.name 
                    : weeksGuidelines[0].SDA.autonomous 
                    ? 'Autónomo' 
                    : weeksGuidelines[0].SDA.questions.length > 0
                    ? weeksGuidelines[0].SDA.final_score.toFixed(2) + "%"
                    : "No realizado",
                  sdb: !SD
                    ? "N/A"
                    : weeksGuidelines[0].SDB.typeimpediment 
                    ? weeksGuidelines[0].SDB.typeimpediment.name 
                    : weeksGuidelines[0].SDB.autonomous 
                    ? 'Autónomo' 
                    : weeksGuidelines[0].SDB.questions.length > 0
                    ? weeksGuidelines[0].SDB.final_score.toFixed(2) + "%"
                    : "No realizado",
                  cp: !CP
                    ? "N/A"
                    : weeksGuidelines[0].CP.typeimpediment 
                    ? weeksGuidelines[0].CP.typeimpediment.name 
                    : weeksGuidelines[0].CP.autonomous 
                    ? 'Autónomo' 
                    : weeksGuidelines[0].CP.questions.length > 0
                    ? weeksGuidelines[0].CP.final_score.toFixed(2) + "%"
                    : "No realizado",
                  id_eval: weeksGuidelines[0].id,
                  user_evaluated: weeksGuidelines[0].user_evaluated
                });
                vm.totalRows++;
              }
            }
          
          vm.renderedItems = vm.items.slice(
            (vm.currentPage - 1) * vm.perPage,
            vm.currentPage * vm.perPage
          );
        });
      });
      loading.hide();
    },
    changeYear($event) {
      this.$nextTick(() => {
        const vm = this;
        vm.getEvaluations();
      })
    },
    getYears() {
      return new Promise((res, rej) => {
        try {
          const vm = this;
          let currentYear = new Date().getFullYear();
          let startYear = 2019;
          let yearslist = [];  
          while ( startYear <= currentYear ) {
              yearslist.push(startYear++);
          }   
          vm.years = yearslist;
          vm.year = currentYear;
          res();
        } catch (e) {
          rej(e);
        }
      });
    }
  },
  mounted() {
    this.$nextTick(() => {
      const vm = this;
      vm.getYears().then(() => {
        vm.getEvaluations();
      });
    })  
  }
};
</script>




// WEBPACK FOOTER //
// src/views/consultor-externo/consultor-externo-pauta-resumen.vue